// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__y_zYF","skeletonCircle":"Skeleton_skeletonCircle__7E6aX","skeletonSlide":"Skeleton_skeletonSlide__xwOhV","leftToRight":"Skeleton_leftToRight__Y_7XS"};